import { Modal } from '@superops/ui-design-system';
import React from 'react';
import { TicketDetailsPage } from '@nile/mangifera/src/Pages/TicketDetails/index.js';
import { GET_TICKET, useCachedQuery } from '@nile/graphql';
import {
  COMMON_CONSTANTS,
  SkeletonLoading,
  useProduct
} from '@nile/components';
import { useFlags } from 'launchdarkly-react-client-sdk';

export function TicketDetailsModal({ ticket: ticketProp, onClose }) {
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const { loading, data } = useCachedQuery(GET_TICKET, {
    variables: { id: ticketProp.ticketId, isMSPProduct }
  });

  const flags = useFlags();

  return (
    <Modal open onClose={onClose} large>
      <div className="vh80">
        {loading ? (
          <SkeletonLoading
            hideStepNav
            hideTable
            showPlainCardView={false}
            showCardView={false}
            showConversationCard
            showPropertyCard
            showInsighteCard
          />
        ) : (
          <TicketDetailsPage
            ticket={data?.getTicket}
            flags={flags}
            concurrentViewers={[]}
            readOnly
            isMSPProduct={isMSPProduct}
          />
        )}
      </div>
    </Modal>
  );
}
